@if (mode === 'inline') {
  <div class="filters-row">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        [value]="values.selectedAgentGroupId"
        [placeholder]="'All Agent Groups' | translate"
        (valueChange)="onFieldChange('selectedAgentGroupId', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="agentGroups.query"
            (ngModelChange)="agentGroups.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">{{ 'All Agent Groups' | translate }}</mat-option>
        @for (group of agentGroups.filtered; track trackById($index, group)) {
          <mat-option [value]="group.id">{{ group.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        [value]="values.selectedShiftType"
        [placeholder]="'All Shift Types' | translate"
        (valueChange)="onFieldChange('selectedShiftType', $event)">
        <mat-option [value]="null">{{ 'All Shift Types' | translate }}</mat-option>
        @for (opt of shiftTypeOptions; track trackById($index, opt)) {
          <mat-option [value]="opt.id">{{ opt.name | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        multiple
        [ngModel]="values.selectedAgentIds"
        [placeholder]="'All Agents' | translate"
        (ngModelChange)="onFieldChange('selectedAgentIds', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="agents.query"
            (ngModelChange)="agents.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        @for (agent of agents.display; track trackById($index, agent)) {
          <mat-option [value]="agent.id">
            {{ agent.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        multiple
        [ngModel]="values.selectedSegIds"
        [placeholder]="'All SEGs' | translate"
        (ngModelChange)="onFieldChange('selectedSegIds', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="segs.query"
            (ngModelChange)="segs.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        @for (seg of segs.display; track trackById($index, seg)) {
          <mat-option [value]="seg.id">
            {{ seg.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select
        multiple
        [ngModel]="values.selectedSurveyTypeIds"
        [placeholder]="'All Survey Types' | translate"
        (ngModelChange)="onFieldChange('selectedSurveyTypeIds', $event)">
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="surveyTypes.query"
            (ngModelChange)="surveyTypes.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
          </ngx-mat-select-search>
        </mat-option>
        @for (type of surveyTypes.display; track trackById($index, type)) {
          <mat-option [value]="type.id">
            {{ type.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select [value]="values.selectedStackBy"
        (valueChange)="onFieldChange('selectedStackBy', $event)">
        @for (opt of stackByOptions; track trackById($index, opt)) {
          <mat-option [value]="opt.id">
            {{ opt.name | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field">
      <mat-select [value]="values.selectedGranularity"
        (valueChange)="onFieldChange('selectedGranularity', $event)">
        @for (opt of granularityOptions; track trackById($index, opt)) {
          <mat-option [value]="opt.id"
            [disabled]="opt.id < granularityFloor">
            {{ opt.name | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field filter-field-wide">
      <mat-select [value]="values.selectedTimeRange"
        (valueChange)="onTimeRangeChange($event)">
        @for (opt of timeRangeOptionsWithRange; track trackById($index, opt)) {
          <mat-option [value]="opt.id">
            {{ opt.id === SampleMetricsTimeRange.Custom ? customTimeRangeLabel : opt.displayName }}
          </mat-option>
        }
      </mat-select>
      @if (values.selectedTimeRange === SampleMetricsTimeRange.Custom) {
        <button
          matSuffix mat-icon-button
          type="button"
          (click)="$event.stopPropagation(); openCustomDateDialog(values.selectedTimeRange)"
          [attr.aria-label]="'Edit custom date range' | translate">
          <mat-icon>edit_calendar</mat-icon>
        </button>
      }
    </mat-form-field>
    <ng-content select="[filterAppend]"></ng-content>
  </div>
}

@if (mode === 'config') {
  <div class="widget-config-fields">
    <div class="config-field">
      <label>{{ 'Agent Group' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select [value]="values.selectedAgentGroupId"
          [placeholder]="'All Agent Groups' | translate"
          (valueChange)="onFieldChange('selectedAgentGroupId', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="agentGroups.query"
              (ngModelChange)="agentGroups.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="null">{{ 'All Agent Groups' | translate }}</mat-option>
          @for (group of agentGroups.filtered; track trackById($index, group)) {
            <mat-option [value]="group.id">{{ group.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'Shift Type' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select [ngModel]="values.selectedShiftType"
          (ngModelChange)="onFieldChange('selectedShiftType', $event)">
          <mat-option [value]="null">{{ 'All Shift Types' | translate }}</mat-option>
          @for (opt of shiftTypeOptions; track trackById($index, opt)) {
            <mat-option [value]="opt.id">{{ opt.name | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'Agents' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          multiple
          [ngModel]="values.selectedAgentIds"
          [placeholder]="'All Agents' | translate"
          (ngModelChange)="onFieldChange('selectedAgentIds', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="agents.query"
              (ngModelChange)="agents.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (agent of agents.display; track trackById($index, agent)) {
            <mat-option [value]="agent.id">
              {{ agent.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'SEGs' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          multiple
          [ngModel]="values.selectedSegIds"
          [placeholder]="'All SEGs' | translate"
          (ngModelChange)="onFieldChange('selectedSegIds', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="segs.query"
              (ngModelChange)="segs.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (seg of segs.display; track trackById($index, seg)) {
            <mat-option [value]="seg.id">
              {{ seg.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'Survey Type' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select
          multiple
          [ngModel]="values.selectedSurveyTypeIds"
          [placeholder]="'All Survey Types' | translate"
          (ngModelChange)="onFieldChange('selectedSurveyTypeIds', $event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="surveyTypes.query"
              (ngModelChange)="surveyTypes.search($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (type of surveyTypes.display; track trackById($index, type)) {
            <mat-option [value]="type.id">
              {{ type.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'Stack By' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select [ngModel]="values.selectedStackBy"
          (ngModelChange)="onFieldChange('selectedStackBy', $event)">
          @for (opt of stackByOptions; track trackById($index, opt)) {
            <mat-option [value]="opt.id">{{ opt.name | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'Granularity' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select [ngModel]="values.selectedGranularity"
          (ngModelChange)="onFieldChange('selectedGranularity', $event)">
          @for (opt of granularityOptions; track trackById($index, opt)) {
            <mat-option [value]="opt.id"
            [disabled]="opt.id < granularityFloor">{{ opt.name | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="config-field">
      <label>{{ 'Time Range' | translate }}</label>
      <mat-form-field appearance="outline" class="config-select">
        <mat-select [value]="values.selectedTimeRange"
          (valueChange)="onTimeRangeChange($event)">
          @for (opt of timeRangeOptionsWithRange; track trackById($index, opt)) {
            <mat-option [value]="opt.id">
              {{ opt.id === SampleMetricsTimeRange.Custom ? customTimeRangeLabel : opt.displayName }}
            </mat-option>
          }
        </mat-select>
        @if (values.selectedTimeRange === SampleMetricsTimeRange.Custom) {
          <button
            matSuffix mat-icon-button
            type="button"
            (click)="$event.stopPropagation(); openCustomDateDialog(values.selectedTimeRange)"
            [attr.aria-label]="'Edit custom date range' | translate">
            <mat-icon>edit_calendar</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </div>
}
